/**
 * Normalise une chaîne pour une comparaison de recherche insensible à la casse
 * et aux accents (ex. "Côte d'Ivoire" et "cote d'ivoire" deviennent identiques).
 */
export const normalizeSearchTerm = (value: string): string =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const searchTextValue = (str: string, value: string): boolean => {
  if (value.length === 0) return true;
  if (str.length < value.length) return false;

  for (let i = 0; i <= str.length - value.length; i++) {
    let found = true;
    for (let j = 0; j < value.length; j++) {
      if (str[i + j] !== value[j]) {
        found = false;
        break;
      }
    }
    if (found) {
      return true;
    }
  }
  return false;
};
